import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
} from '@mui/material';
import { WIDGET_URL } from '../../../../config';
import BlockWithTitle from '../../../components/atom/BlockWithTitle';
import { useTranslation } from 'react-i18next';
import PreBlock from './PreBlock';

function OnboardingGuide({ shows = [], venueSlug = '' }) {
    const { t } = useTranslation();
    return (
        <BlockWithTitle title={t('onboarding.title')}>
            {/* minWidth:0 lets this flex child shrink to the card width so the code
                blocks/table inside can scroll instead of expanding past it. */}
            <div style={{ textAlign: 'left', width: '100%', minWidth: 0 }}>
                <Typography variant="body1" gutterBottom>
                    {t('onboarding.description')}
                </Typography>
                <PreBlock>
                    &lt;script type="module" src="{WIDGET_URL}/index.js"&gt;&lt;/script&gt;
                    <br />
                    &lt;div id="fireknife-widget-root"&gt;&lt;/div&gt;
                </PreBlock>
                <Typography variant="body1" gutterBottom>
                    {t('onboarding.way1')}
                </Typography>
                <PreBlock>window.showFireknifeReservation(1234);</PreBlock>
                <Typography variant="body1" gutterBottom>
                    {t('onboarding.way2')}
                </Typography>
                <PreBlock>
                    &lt;a href="javascript:window.showFireknifeReservation(1234);"&gt;
                    {t('onboarding.bookNow')}
                    &lt;/a&gt;
                </PreBlock>

                <Typography variant="body1" gutterBottom>
                    {t('onboarding.way3')}
                </Typography>
                <TableContainer>
                    <Table sx={{ minWidth: 640 }}>
                        <TableHead>
                            <TableRow>
                                <TableCell>{t('onboarding.showName')}</TableCell>
                                <TableCell>{t('onboarding.showCall')}</TableCell>
                                <TableCell>{t('onboarding.directSite')}</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {shows.map((show) => (
                                <TableRow key={show.id}>
                                    <TableCell>{show.title}</TableCell>
                                    <TableCell>
                                        <PreBlock>
                                            window.showFireknifeReservation({show.id});
                                        </PreBlock>
                                    </TableCell>
                                    <TableCell>
                                        <a
                                            href={`${WIDGET_URL}/${venueSlug}-${show.id}`}
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            {`${WIDGET_URL}/${venueSlug}-${show.id}`}
                                        </a>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>
        </BlockWithTitle>
    );
}

export default OnboardingGuide;
